jQuery('document').ready(function($){
  // Sidecart
  $('body').on('click', '.primary-menu-toggle', function(){
    $('.primary-menu-toggle').toggleClass('is-open');
    $('.sticky-primary-navigation').toggleClass('is-open');
  });
});